import request from '@/utils/request'

export const checkForUpdates = () =>
  request({
    url: `/system/update/check`,
    method: 'get',
    timeout: 15000
  })
export const applyUpdate = () =>
  request({
    url: `/system/update/apply`,
    method: 'post',
    timeout: 15000
  })
export const checkStoreStatus = () =>
  request({
    url: `/system/store/status`,
    method: 'get'
  })
export const enableStore = () =>
  request({
    url: `/system/store/enable`,
    method: 'post'
  })
export const disableStore = () =>
  request({
    url: `/system/store/disable`,
    method: 'post'
  })
export const getNotifications = () =>
  request({
    url: `/system/notifications`,
    method: 'get'
  })
export const assignToTask = (notificationId: number) =>
  request({
    url: `/system/notifications/assign/${notificationId.toString()}`,
    method: 'post'
  })
export const removeFromTask = (notificationId: number) =>
  request({
    url: `/system/notifications/remove/${notificationId.toString()}`,
    method: 'post'
  })
